/**
 * 错误上报开关：读取 `/system/basic/conf` 的 `is_enabled`（1 开 / 0 关）
 * 独立小模块，避免 errorConfig ↔ store/request 循环依赖。
 */

export function isErrorReportEnabledFlag (value) {
  return value === 1 || value === '1' || value === true
}

/**
 * @returns {boolean|null} null 表示配置里尚无该字段
 */
export function readErrorReportEnabledFromConfObject (conf) {
  if (!conf || typeof conf !== 'object') return null
  if (!Object.prototype.hasOwnProperty.call(conf, 'is_enabled')) return null
  return isErrorReportEnabledFlag(conf.is_enabled)
}

/** PC：读 localStorage systemConf */
export function readErrorReportEnabledFromLocalStorage () {
  try {
    if (typeof localStorage === 'undefined') return null
    const raw = localStorage.getItem('systemConf')
    if (!raw) return null
    const conf = JSON.parse(raw)
    return readErrorReportEnabledFromConfObject(conf)
  } catch (e) {
    return null
  }
}
